/* eslint-disable no-undef */

// Automatically import all sprites
function requireAll(r) {
  r.keys().forEach(r);
}

if (!process || process.env.NODE_ENV !== "test") {
  requireAll(require.context("./", true, /\.svg$/));
}
